import React, { useState } from 'react';
import { HeaderBar, Wrapper, CtaButton, Footer, CARD } from './Shared';
import { track, sendLead, saveLead, getLead, firstName } from './pixel';
import { PRIVACY_URL } from './config';

// PASO 2: preguntas de filtro, una por pantalla (estilo aplicación). Ya dio sus datos -> alta tasa de finalización.
type Q = {
  key: string;
  q: string;
  options?: string[];
  stopIf?: string;
};
const QUESTIONS: Q[] = [{
  key: 'work_auth',
  q: '¿Tienes autorización para trabajar en Estados Unidos?',
  options: ['Sí', 'No'],
  stopIf: 'No'
}, {
  key: 'license',
  q: '¿Estás dispuesto/a a sacar una licencia estatal de seguros de vida? Te acompañamos en todo el proceso.',
  options: ['Sí, estoy listo/a', 'Tengo dudas, quiero saber más', 'No'],
  stopIf: 'No'
}, {
  key: 'hours',
  q: '¿Cuántas horas por semana podrías dedicarle?',
  options: ['Menos de 5', '5 a 10', '10 a 20', 'Más de 20']
}, {
  key: 'costs',
  q: 'Empezar tiene costos de inscripción y licencia. ¿Quieres que te los explique en la llamada antes de decidir?',
  options: ['Sí, quiero conocerlos', 'Necesito más información', 'No por ahora']
}, {
  key: 'why',
  q: 'Última: ¿por qué quieres construir algo propio? Cuéntame en 2 o 3 líneas.'
}];
export function Qualify({
  onDone
}: {
  onDone: () => void;
}) {
  const [i, setI] = useState(0);
  const [answers, setAnswers] = useState<Record<string, string>>({});
  const [why, setWhy] = useState('');
  const [consent, setConsent] = useState(false);
  const [err, setErr] = useState('');
  const [stopped, setStopped] = useState(false);
  const name = firstName();
  const q = QUESTIONS[i];
  const pct = Math.round((i + 1) / QUESTIONS.length * 100);
  const pick = async (opt: string) => {
    const next = {
      ...answers,
      [q.key]: opt
    };
    setAnswers(next);
    if (q.stopIf && opt === q.stopIf) {
      setStopped(true);
      await sendLead({
        step: 'no_califica',
        ...getLead(),
        ...next
      });
      return;
    }
    setI(i + 1);
  };
  const finish = async (e: React.FormEvent) => {
    e.preventDefault();
    if (why.trim().length < 20) return setErr('Cuéntame un poquito más (mínimo 20 caracteres).');
    if (!consent) return setErr('Necesito tu autorización para contactarte por WhatsApp.');
    const all = {
      ...answers,
      why,
      consent: true,
      consent_at: new Date().toISOString()
    };
    saveLead(all);
    await sendLead({
      step: 'aplicacion',
      ...getLead(),
      ...all
    });
    track('SubmitApplication');
    onDone();
  };
  return <div className="bg-white min-h-screen flex flex-col" data-id="element-515" data-mp="2e6dhbts1m44j">
      <HeaderBar data-id="element-516" data-mp="2j2u7sumpsuks" />
      <section className="flex-1 pt-10 sm:pt-16 pb-20 sm:pb-24" data-id="element-517" data-mp="2j4f2qlcxyfj6">
        <Wrapper className="max-w-[760px] text-center" data-id="element-518" data-mp="2o274s87avi13">
          {!stopped && <>
              <p className="font-semibold text-brand text-[14px] sm:text-[15px]" data-id="element-519" data-mp="2t2con27bw08m">Paso 2 de 2 · Ya casi terminas</p>
              <div className="mt-3 h-2 rounded-full bg-brand-light overflow-hidden" data-id="element-520" data-mp="3darmhqp7vjo">
                <div className="h-full rounded-full bg-brand transition-[width] duration-300 ease-out" style={{
              width: `${pct}%`
            }} data-id="element-521" data-mp="8b2prthxsdwb" />
              </div>
              <p className="mt-6 font-bold text-[18px] sm:text-[22px] text-ink" data-id="element-522" data-mp="1svpppvxge89h">{name ? `${name}, ` : ''}respondes 5 preguntas rápidas y eliges tu horario.</p>
            </>}

          {stopped ? <div className={`${CARD} mt-4 p-6 sm:p-10 step-in`} data-id="element-523" data-mp="1j1gzjevwareh">
              <h2 className="font-extrabold tracking-tight text-[24px] sm:text-[32px] leading-tight text-ink" data-id="element-524" data-mp="1e3xiy8bq62jd">Gracias por tu sinceridad{name ? `, ${name}` : ''}.</h2>
              <p className="mt-4 text-[16px] sm:text-[20px] text-gray-700 leading-snug" data-id="element-525" data-mp="153ixn8yrgnfv">Por ahora este programa requiere autorización para trabajar en EE.UU. y obtener una licencia estatal. Si tu situación cambia, aquí estaré.</p>
            </div> : <div key={i} className={`${CARD} mt-6 p-6 sm:p-10 text-left step-in`} data-id="element-526" data-mp="v7z24no3zqrn">
              <p className="text-[13px] font-semibold text-brand" data-id="element-527" data-mp="2ui7997zj21cu">Pregunta {i + 1} de {QUESTIONS.length}</p>
              <h2 className="mt-2 font-extrabold tracking-tight text-[22px] sm:text-[30px] leading-tight text-ink" data-id="element-528" data-mp="2pht0fnq3qndr">{q.q}</h2>

              {q.options ? <div className="mt-6 grid gap-3" data-id="element-529" data-mp="1r71kbeproq4u">
                  {q.options.map(o => <button key={o} type="button" onClick={() => pick(o)} className={`w-full rounded-xl border-2 px-5 py-4 sm:py-5 text-left text-[17px] sm:text-[19px] font-semibold transition-colors duration-150 ease-out ${answers[q.key] === o ? 'border-brand bg-brand text-white' : 'border-gray-200 bg-white text-ink hover:border-brand'}`} data-id="element-530" data-mp="1d936qbj9sxqe">
                      {o}
                    </button>)}
                </div> : <form id="qualForm" onSubmit={finish} className="mt-6 space-y-5" data-id="element-531" data-mp="zgn9xsgypvxx">
                  <textarea value={why} onChange={e => {
              setWhy(e.target.value);
              if (err) setErr('');
            }} placeholder="Quiero construir algo propio porque…" aria-label="¿Por qué quieres construir algo propio?" className="w-full min-h-[140px] rounded-xl border border-gray-200 bg-white px-5 py-4 text-[16px] sm:text-[18px] text-ink outline-none transition-[border-color,box-shadow] duration-150 ease-out focus:border-brand focus:ring-4 focus:ring-brand-light placeholder:text-gray-400" data-id="element-532" data-mp="kjmilq2oo2zz" />
                  <label className="flex items-start gap-3 text-[13px] sm:text-[14px] leading-relaxed text-gray-600" data-id="element-533" data-mp="avqzppj0lwxz">
                    <input type="checkbox" checked={consent} onChange={e => {
                setConsent(e.target.checked);
                if (err) setErr('');
              }} className="mt-0.5 h-5 w-5 shrink-0 accent-[#1F4BFF]" data-id="element-534" data-mp="ougwt55u3wmc" />
                    <span data-id="element-535" data-mp="ykjn2xlkmwgz">Acepto ser contactado/a por llamada, SMS, WhatsApp o email sobre esta solicitud. Pueden aplicar tarifas de mensajes y datos. Puedo cancelar en cualquier momento respondiendo STOP. <a href={PRIVACY_URL} className="underline" data-id="element-536" data-mp="18j94kp9k2ewp">Política de privacidad</a>.</span>
                  </label>
                  {err && <p role="alert" className="text-sm font-medium text-red-600" data-id="element-537" data-mp="13m918m43bq9a">{err}</p>}
                  <CtaButton type="submit" form="qualForm" label="Ver video y elegir mi horario" sub="Último paso" data-id="element-538" data-mp="1ap76dhv7sz5x" />
                </form>}

              {i > 0 && <button type="button" onClick={() => setI(i - 1)} className="mt-5 text-[14px] font-medium text-gray-500 underline underline-offset-4" data-id="element-539" data-mp="1kmbuhn8mf4pd">← Volver</button>}
            </div>}
        </Wrapper>
      </section>
      <Footer data-id="element-540" data-mp="1uatrruhoyto9" />
    </div>;
}